export const environment = {
   production: true,

   websiteUrl: 'https://maltech.co',

   baseUrl: 'https://maltech.co/api',

   surveyapp_baseurl: 'https://peoplesurvey.info',

   blogUrl: 'https://maltech.co/blog/',
      
   apiBaseUrl: 'https://maltech.email/api/api',


  // maltech python
  applyIntershipApi: '/internship-applications/',
  problemstatement: '/problem-statements/public',
  problemid: '/problem-statements/public/',
  problem_statement_upload: '/upload/files/',
  applyProblemApi: '/problem-statement-applications/',
  applyJobApi: '/job-applications/',
  FetchCareerDetails: '/careers/public/list',
  getJobDetailApiUrl: '/careers/public/',
  getCountry: '/Common/getallcountries',
  getState: '/Common/getallstates',
  s3bucket: '/upload/files', 



  // emailtech
  contactUsApiUrl:'/contact-us/',
  applyJobEndpoint: '/job-applications/',
  
 // emailtech
  etAddAccount: '/Account/AddCustomerAccount',
  etUpdateAccount: '/Account/UpdateCustomerAccount',
};